import React, { useContext, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import LoginContext from '../../context'

const sidebarData = [
    {
        "title": "입금신청",
        "icon_name": "fi fi-rr-donate",
        "link": "/cash_1",
    },
    {
        "title": "출금신청",
        "icon_name": "fi fi-rr-money-from-bracket",
        "link": "/cash_2",
    },
    {
        "title": "배팅내역",
        "icon_name": "fi fi-rr-list-dropdown",
        "link": "/betting",
    },
    {
        "title": "경기결과",
        "icon_name": "fi fi-rr-trophy-star",
        "link": "/result",
    },
    {
        "title": "출석하기",
        "icon_name": "fi fi-rr-calendar-check",
        "link": "#",
    },
    {
        "title": "쿠폰함",
        "icon_name": "fi fi-rr-ticket",
        "link": "/coupon",
    },
    {
        "title": "마이페이지",
        "icon_name": "fi fi-rr-user-gear",
        "link": "#",
    },
    {
        "title": "추천내역",
        "icon_name": "fi fi-rr-user-add",
        "link": "/recommend_list",
    },
    {
        "title": "이벤트",
        "icon_name": "fi fi-rr-gift",
        "link": "/event",
    },
    {
        "title": "공지사항",
        "icon_name": "fi fi-rr-bullhorn",
        "link": "/notice",
    },
    {
        "title": "고객센터",
        "icon_name": "fi fi-rr-headphones",
        "link": "/customer",
    },
    {
        "title": "로그아웃",
        "icon_name": "fi fi-rr-sign-out-alt",
        "link": "/logout",
    }
]
const MobileSidebar = ({ isOpen, referance, onClose}) => {

    const {logout} = useContext(LoginContext)
    const handleLinkOpen=(e, link)=>{
        if (link === "/logout") {
            e.preventDefault()
            onClose()
            logout()
            // Add your logout logic here
        }
    }
    const location = useLocation();
        useEffect(() => {   
            onClose()
        }, [location]);
    
    return (
        <>
            <section className={`${isOpen ? 'translate-x-0' : '-translate-x-[150%]'} max-w-[100px] fixed w-full h-full z-[9990] bg-obsidian overflow-auto box-border shadow-[10px_0_30px_rgba(0,0,0,0.6)] transition-all duration-[0.3s] ease-[cubic-bezier(0.35,0.38,0.07,0.83)] left-0 top-0`} ref={referance}>
                <ul >
                    {sidebarData.map((item, index) => (
                        <li key={index} className='block  py-[11px] border-b-[#2c2925] border-b '>
                            <Link to={item.link} className='text-[#a09d99] font-bold text-center text-xs block' onClick={(e)=>handleLinkOpen(e, item.link)}><i className={`${item.icon_name} text-[21px] text-aquaBlue block mb-1`}></i> <span>{item.title}</span></Link>
                        </li>
                    ))}
                </ul>
            </section>
        </>
    )
}

export default MobileSidebar